import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from "react";
import SearchResult from "./search/search-result";
import LoadingSpinner from "./common/loading-spinner";
import { globalHistory } from "@reach/router";
const SearchResultPreview = _ref => {
    let { hit } = _ref;
    const { slug, title, text, authors, publishDate: pubDate, content: body } = hit;
    return /*#__PURE__*/ React.createElement(SearchResult, {
        result: {
            slug,
            title,
            text,
            body,
            authors,
            pubDate
        }
    });
};
const InfiniteHits = _ref2 => {
    let { hits, loadNextPage, hasMore } = _ref2;
    return /*#__PURE__*/ React.createElement("div", null, hits.map(hit => /*#__PURE__*/ React.createElement(SearchResultPreview, {
        hit: hit,
        key: hit.id
    })), /*#__PURE__*/ React.createElement("button", {
        disabled: !hasMore,
        className: `bg-gray-400 px-3 py-2 hover:text-white hover:bg-makroOrange ${!hasMore ? "hidden" : ""}`,
        onClick: loadNextPage
    }, "weitere Ergebnisse laden"));
};
let Search = /*#__PURE__*/ function (_React$Component) {
    function Search(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.getSearchResults = async function (val, offset) {
            if (offset === void 0) {
                offset = 0;
            }
            if (val && val.length >= 2) {
                _this.setState({
                    isLoading: true
                });
                try {
                    const data = await fetch("https://search.makroskop.eu/indexes/articles/search", {
                        method: "POST",
                        headers: {
                            "X-Meili-API-Key": "2e2e74bc1ea52117ec3ba0bdcf8233c224a396a63a03f75c121d62c9ce44f3cb",
                            Accept: "application/json"
                        },
                        body: JSON.stringify({
                            q: val,
                            offset,
                            limit: _this.state.limit
                        })
                    }).then(res => res.json());
                    _this.setState({
                        isLoading: false
                    });
                    return data;
                }
                catch (err) {
                    console.error(err);
                    _this.setState({
                        isLoading: false
                    });
                }
            }
        };
        _this.loadNextPage = async () => {
            if (!_this.state.isLoading) {
                var _data$hits;
                const { offset, limit } = _this.state;
                const newOffset = offset + limit;
                const data = await _this.getSearchResults(_this.state.searchText, newOffset);
                if (data !== null && data !== void 0 && (_data$hits = data.hits) !== null && _data$hits !== void 0 && _data$hits.length) {
                    _this.setState(prevState => ({
                        results: [].concat(_toConsumableArray(prevState.results), _toConsumableArray(data.hits)),
                        offset: newOffset,
                        nbHits: data.nbHits
                    }));
                }
            }
        };
        _this.doSearch = async (val) => {
            _this.setState({
                searchText: val,
                offset: 0
            });
            const data = await _this.getSearchResults(val);
            if (data) {
                _this.setState({
                    results: data.hits,
                    nbHits: data.nbHits,
                    offset: 0
                });
            }
        };
        _this.searchOnChange = async (val) => {
            window.history.pushState(null, document.title, `${window.location.pathname}?search=${encodeURI(val)}`);
            await _this.doSearch(val);
        };
        _this.state = {
            searchText: "",
            results: [],
            isLoading: false,
            offset: 0,
            limit: 20,
            nbHits: 0
        };
        return _this;
    }
    _inheritsLoose(Search, _React$Component);
    var _proto = Search.prototype;
    _proto.componentDidMount = function componentDidMount() {
        globalHistory.listen(_ref3 => {
            let { action, location } = _ref3;
            if (["POP", "PUSH"].includes(action) && location.search.includes("search=")) {
                var _location$search;
                const text = (_location$search = location.search) === null || _location$search === void 0 ? void 0 : _location$search.split("=")[1];
                this.doSearch(decodeURI(text));
            }
            if (window.location.search.includes("search=")) {
                var _window$location$sear;
                const text = (_window$location$sear = window.location.search) === null || _window$location$sear === void 0 ? void 0 : _window$location$sear.split("=")[1];
                this.doSearch(decodeURI(text));
            }
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.visible && !this.props.visible) {
            window.history.pushState(null, document.title, window.location.pathname);
        }
        else if (!prevProps.visible && this.props.visible && window.location.search.includes("search=")) {
            var _window$location$sear2;
            const text = (_window$location$sear2 = window.location.search) === null || _window$location$sear2 === void 0 ? void 0 : _window$location$sear2.split("=")[1];
            this.doSearch(decodeURI(text));
        }
    };
    _proto.render = function render() {
        const { visible, setVisibility } = this.props;
        return /*#__PURE__*/ React.createElement("div", {
            className: "border-solid border-t-8 border-makroOrange bg-white inset-0 z-50" + (visible ? "" : " hidden")
        }, /*#__PURE__*/ React.createElement("div", {
            className: "flex justify-between pt-1 items-start"
        }, /*#__PURE__*/ React.createElement("p", {
            className: "flex w-full text-xl text-makroOrange uppercase"
        }, "SUCHE"), /*#__PURE__*/ React.createElement("button", {
            onClick: () => setVisibility(!visible),
            className: "pb-2"
        }, "schlie\xDFen")), /*#__PURE__*/ React.createElement("div", {
            className: "container mx-auto px-3"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "px-8 py-16 relative"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "mb-4"
        }, /*#__PURE__*/ React.createElement("input", {
            type: "search",
            value: this.state.searchText,
            onChange: e => this.searchOnChange(e.target.value),
            placeholder: "Suchbegriff eingeben",
            className: "text-3xl text-black py-2 border-b border-solid border-black w-full"
        }), /*#__PURE__*/ React.createElement("button", {
            className: "inline-block mt-8 mb-2 px-16 py-1 text-white border-2 border-solid border-makroOrange bg-makroOrange",
            onClick: () => this.doSearch(this.state.searchText)
        }, "LOS")), this.state.isLoading ? /*#__PURE__*/ React.createElement(LoadingSpinner, null) : null, this.state.results.length ? /*#__PURE__*/ React.createElement(InfiniteHits, {
            hits: this.state.results,
            loadNextPage: this.loadNextPage,
            hasMore: this.state.nbHits > this.state.results.length
        }) : null)));
    };
    return Search;
}(React.Component);
export default Search;
